export default __webpack_public_path__ + "static/media/empty-report.aa39cc09.svg";